import React, { useEffect, useState } from 'react';

export const ModernTabs = ({ children, updateTabIndex, hideMainTabs, inverse, onTabClick }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabClick = (tabIndex) => {
    setActiveTabIndex(tabIndex === activeTabIndex ? activeTabIndex : tabIndex)

    if (onTabClick) {
      onTabClick(tabIndex);
    }
  }

  const renderChildrenWithTabProps = () => {
    return React.Children.map(children, (child, index) => {
      return React.cloneElement(child, {
        onClick : handleTabClick,
        tabIndex: index,
        isActive: index === activeTabIndex,
        inverseColor: inverse ? true : false,
      });
    });
  }

  const renderActiveTabContent = () => {
    if(children[activeTabIndex]) {
      return children[activeTabIndex].props.children;
    }
  }

  useEffect(() => {
    if(updateTabIndex) {
      updateTabIndex(renderChildrenWithTabProps());
    }
  }, [activeTabIndex]);

  return (
    <div className="just-tabs">
      {!hideMainTabs && (
        <div className="tabs__navigation">
          {renderChildrenWithTabProps()}
        </div>
      )}
      <div className="tabs__activeContent">
        {renderActiveTabContent()}
      </div>
    </div>
  );
};
